import {FETCH_SUCCESS} from "./actions";
import {Success} from "./types";

const initialState: Success = null;

export function successReducer(
    state = initialState,
    action: any
): Success {
    switch (action.type) {
        case FETCH_SUCCESS: {
            return action.payload;
        }
        default:
            return state
    }
}
